import Anomalies from '@/resources/models/anomalies/Anomalies'
import IQCollection from '@/resources/collections/IQCollection'
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

export default class ProcessAnomalies extends Anomalies {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.tableColAccessor = 'processAnomalyDrillDownResult.exampleExecutions'
    this.tableResultAccessor = 'processAnomalyDrillDownResult.exampleExecutions'
    this.buildTableData(attributes)
  }

  buildTableData (stats) {
    let records = _.map(_.get(stats, this.tableColAccessor), record => {
      return { execution: record }
    })
    this.createTableCol(records[0])
    records.forEach(record => {
      if (!_.isEmpty(record.agentId)) {
        let hostfound = _.find(this.options.hosts, {
          agentNumber: record.agentId
        })
        if (hostfound) {
          record.agentId = hostfound.customHostname
        }
      }
    })
    this.collection = new IQCollection(records, { attributes: this.columns })
  }

  createTableCol (record) {
    this.columns.length = 0
    this.columns.push({
      datatype: 'string',
      description: this.getColumnLabel('execution'),
      label: this.getColumnLabel('execution'),
      name: 'execution',
      'min-width': 100,
      sortable: true
    })
    // for (let key of record) {
    //   let col = {
    //     datatype: 'string',
    //     description: this.getColumnLabel(key),
    //     label: this.getColumnLabel(key),
    //     name: key,
    //     'min-width': 100,
    //     sortable: true
    //   }
    //   if (key === 'timestamp') {
    //     col.datatype = 'datetime'
    //     col.format = DATETIME_FORMAT
    //   }
    //   this.columns.push(col)
    // }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/anomalies/ProcessAnomalies.js